module.exports = __webpack_public_path__ + "static/media/1.19_preview.b38b4c4b.png";